module.exports = __webpack_public_path__ + "img/lens-guide-cover-snow.8435c70.jpg";